import { useChatVRTVisibility } from '../../chatvrt/useChatVRTVisibility';
import { IconButton } from '@vrplatform/components';

export function NavbarChatVRTButton() {
  const { available, disabled, toggleDisabled } = useChatVRTVisibility();

  if (!available) {
    return null;
  }

  return (
    <IconButton
      onClick={toggleDisabled}
      icon={disabled ? 'AiSparkOffIcon' : 'AiSparkIcon'}
      iconSize={18}
      color={(theme) => theme.colors.neutral[3]}
      tooltip={disabled ? 'Show ChatVRT' : 'Hide ChatVRT'}
    />
  );
}
